import { FC } from 'react';

import { StyledContent, StyledEditCard, StyledTitle, StyledTitleContent } from './EditCard.styles';
import { useTranslation } from 'react-i18next';
import { GENETIC_COUNSELING_TRANSLATION } from '@/modules/genetic-counseling/constants/common';
import { EditCardProps } from './EditCard.types';
import { Box } from '@/common/components';

const EditCard: FC<EditCardProps> = ({ children, css, isEditable, isEditing, handleEdit, title }) => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);

  const toggleEdit = (): void => {
    handleEdit?.(!isEditing);
  };

  return (
    <StyledEditCard css={css} data-testid={'edit-card'}>
      <StyledTitleContent>
        <StyledTitle>{title}</StyledTitle>
        {isEditable && (
          <StyledTitle css={{ cursor: 'pointer' }} data-testid={'edit-card-toggle-button'} onClick={toggleEdit}>
            {isEditing ? (
              <Box data-testid={'edit-card-cancel-button'}>{t('patient_profile.cancel')}</Box>
            ) : (
              <Box data-testid={'edit-card-edit-button'}>{t('patient_profile.edit')}</Box>
            )}
          </StyledTitle>
        )}
      </StyledTitleContent>
      <StyledContent>{children}</StyledContent>
    </StyledEditCard>
  );
};

export default EditCard;
